import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_select, {
      class: _normalizeClass(["w100", _ctx.class]),
      value: _ctx.innerValue,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event)),
      disabled: _ctx.disabled,
      placeholder: _ctx.placeholder,
      "allow-clear": "",
      "option-filter-prop": "title",
      onChange: _ctx.onChange,
      onClear: _ctx.onClear
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_select_option, {
          title: _ctx.trueText,
          value: "1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trueText), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_a_select_option, {
          title: _ctx.falseText,
          value: "0"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.falseText), 1)
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }, 8, ["value", "disabled", "placeholder", "class", "onChange", "onClear"])
  ]))
}